<aside class="col-xs-12 col-sm-12 col-md-12 immunization-schedules-aside">
  <div class="row">
    <div class="col-md-12">
      <ul class="acc-banner">
        <li>
          @if (imgUrl1) {
            <div class="square-banner">
              <img [src]="imgUrl1" class="img-fluid" alt="banner1" />
            </div>
          }
        </li>
        <li>
          @if (imgUrl2) {
            <div class="square-banner">
              <img [src]="imgUrl2" class="img-fluid" alt="banner2" />
            </div>
          }
        </li>
      </ul>
    </div>
  </div>
</aside>
